import { regex } from '../../../validator/isDataType';

export const consignmentDynamicFormFields = [
  {
    id: 'consignment-section',
    heading: 'Consignment Details',
    className: 'consignment-section',
    headerAction: {
      type: 'text',
      label: 'Dimensions per box (cm)',
      className: 'consignment-header-action'
    },
    fields: [
      {
        id: 'no-of-boxes',
        name: 'noOfBoxes',
        type: 'TEXT',
        displayName: 'No of Boxes',
        value: '',
        error: '',
        validation: {
          rule: {
            required: { isRequired: true },
            regex: { pattern: regex.integerNumber }
          }
        }
      },
      {
        id: 'dimensions-combine',
        name: 'dimensions',
        type: 'COMBINE',
        className: 'dimensions-row',
        attributes: [
          {
            id: 'height',
            name: 'height',
            type: 'TEXT',
            displayName: 'Height',
            value: '',
            error: '',
            className: 'dimension-field',
            validation: {
              rule: {
                required: { isRequired: true },
                regex: { pattern: regex.wholeNumberUpTo5Decimal }
              }
            }
          },
          {
            id: 'width',
            name: 'width',
            type: 'TEXT',
            displayName: 'Width',
            value: '',
            error: '',
            className: 'dimension-field',
            validation: {
              rule: {
                required: { isRequired: true },
                regex: { pattern: regex.wholeNumberUpTo5Decimal }
              }
            }
          },
          {
            id: 'length',
            name: 'length',
            type: 'TEXT',
            displayName: 'Length',
            value: '',
            error: '',
            className: 'dimension-field',
            validation: {
              rule: {
                required: { isRequired: true },
                regex: { pattern: regex.wholeNumberUpTo5Decimal }
              }
            }
          }
        ]
      },
      {
        id: 'weight',
        name: 'weight',
        type: 'TEXT',
        displayName: 'Weight (kg)',
        value: '',
        error: '',
        validation: {
          rule: {
            required: { isRequired: true },
            regex: { pattern: regex.wholeNumberUpTo5Decimal }
          }
        }
      }
    ]
  },
  {
    id: 'invoice-section',
    heading: 'Invoice Details',
    className: 'invoice-section',
    headerAction: {
      type: 'link',
      label: 'Download Invoice',
      icon: 'a-icon boschicon-bosch-ic-download-frame',
      className: 'Invoice-header-action'
    },
    fields: [
      {
        id: 'invoice-no',
        name: 'invoiceNo',
        type: 'TEXT',
        displayName: 'Invoice No',
        value: '',
        error: '',
        validation: {
          rule: {
            required: { isRequired: true }
          }
        }
      },
      {
        id: 'invoice-date',
        name: 'invoiceDate',
        type: 'DATE',
        displayName: 'Invoice Date',
        value: '',
        error: '',
        validation: {
          rule: {
            required: { isRequired: true }
          }
        }
      }
    ]
  },
  {
    id: 'pickup-location-section',
    heading: 'Pick Up Location',
    className: '',
    fields: [
      {
        id: 'pickup-location',
        name: 'pickupLocation',
        type: 'SINGLE_SELECT_WITH_SEARCH',
        displayName: 'Choose Pickup Location',
        value: '',
        error: '',
        fullWidth: true,
        options: [],
        validation: {
          rule: {
            required: { isRequired: true }
          }
        }
      }
    ]
  }
];
